import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'DownloadMenuItems',
  components: {
    FibCommonModal: require("../../components/CommonModal").default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDefault: false,
      showSuccess: false,
      showWait: false,
      showError: false
    };
  },
  watch: {
    value: function value(activated) {
      if (activated) {
        this.downloadMenuItems();
      }
    }
  },
  methods: {
    done: function done(result) {
      this.$emit('done', {
        name: 'config',
        result: result
      });
      this.$emit('input');
    },
    downloadMenuItems: function downloadMenuItems() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.showWait = true;
                _context.next = 3;
                return _this.$store.dispatch('products/exportMenuData');

              case 3:
                res = _context.sent;
                _this.showWait = false;

                if (res) {
                  _this.showSuccess = true;
                } else {
                  _this.showError = true;
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};